import type { TSGBrand } from '@thesavingsgroup/remote-configuration/types/TSGBrand';

export const brandOrder: TSGBrand[] = ['autopay', 'rateGenius', 'tresl'];
